const firebaseConfig = {
    apiKey: "AIzaSyCPh6YFt8CcZI9x9rBoJN9iPJGPwdpvPjs",
    authDomain: "CryptoX-3fd7e.firebaseapp.com",
    projectId: "CryptoX-3fd7e",
    storageBucket: "CryptoX-3fd7e.appspot.com",
    messagingSenderId: "869332117342",
    appId: "1:869332117342:web:1b0b83dd65e050971d91cf"
  };
  export default firebaseConfig;